/* eslint-disable eqeqeq */
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { MyRoutes } from './routes/Routes';
import isMobile from './helpers/detectMobile';
import MobileOnly from './components/MobileOnly.js';
import './assets/icons/fontawesome-pro-5.11.2-web/css/all.css';
import Api from './api';
import CookieBar from './components/CookieBar/CookieBar';
import { useContent, useLoading } from './hooks/customHooks';
import colorFunctions from './helpers/colorFunctions';
import { Helmet } from 'react-helmet';
import routeHelper from './helpers/routeHelper';
import { campaignBranding } from './constants/branding.js';
import NotFoundPage from './pages/NotFoundPage';

function App() {
    const [configLoading, setConfigLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const { content, setContent } = useContent();
    const { loading } = useLoading();

    const { metadata } = content?.global_settings || {};

    useEffect(() => {
        (async () => {
            setConfigLoading(true);
            await updateContent();
            await checkCampaign();
            if (navigator.userAgent.indexOf('iPhone') > 0) {
                document.body.classList.add('iPhone');
            } else if (navigator.userAgent.indexOf('Mac') > 0) {
                document.body.classList.add('mac-os');
            }
            setConfigLoading(false);
        })();

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (content) {
            updateBrand();
        }
        // eslint-disable-next-line
    }, [content]);

    // useEffect(() => {
    //     if (content && content?.global_settings?.age_gate?.state === ageGateState.ON) {
    //         const ageGatePassed = localStorage.getItem('scale-age-gate');
    //         if (!ageGatePassed) {
    //             const path = location?.pathname;
    //             if (!publicRoutes.includes(path) && !path.startsWith('/claim/')) {
    //                 navigate('/', {
    //                     state: {
    //                         ...location?.state,
    //                         pathname: location?.pathname,
    //                     },
    //                 });
    //             }
    //         }
    //     }
    // }, [content]);

    const checkCampaign = async () => {
        const currentPathname = window.location.pathname;
        if (
            currentPathname === '/terms' ||
            currentPathname === '/cookie-policy' ||
            currentPathname === '/privacy-policy' ||
            currentPathname === '/faqs' ||
            currentPathname.startsWith('/claim/')
        ) {
            return;
        }
        let checkCampaignResponse = await Api.checkCampaign();
        if (!checkCampaignResponse.result) {
            routeHelper(checkCampaignResponse?.error?.type, content, navigate);
        }
    };

    const updateBrand = () => {
        if (!content) return;

        const { colors } = content?.global_settings || {};

        let styleElement = document.getElementById('dynamic-theme-styles');
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = 'dynamic-theme-styles';
            document.head.appendChild(styleElement);
        }

        const cssVariables = ['--gap:16px;', '--green: #25d366;'];

        if (colors) {
            for (const [key, value] of Object.entries(colors)) {
                cssVariables.push(`--${key}: ${value};`);

                if (key === 'primary_opacity') {
                    cssVariables.push(
                        `--primary_color_opacity: ${colorFunctions.hexToRgba(
                            colors['primary'],
                            value
                        )};`
                    );
                }

                for (const alpha of campaignBranding.alphaValues) {
                    cssVariables.push(
                        `--${key}_alpha_${alpha.ex}: ${colorFunctions.hexToRgba(
                            value,
                            alpha.value
                        )};`
                    );
                }
            }
        }

        if (campaignBranding.fonts) {
            for (const [key, value] of Object.entries(campaignBranding.fonts)) {
                cssVariables.push(`--${key}: ${value};`);
            }
        }

        styleElement.textContent = `:root { ${cssVariables.join(' ')} }`;
    };

    const updateContent = async () => {
        const campaignContentResponse = await Api.getCampaignContent();
        if (campaignContentResponse && campaignContentResponse.result) {
            setContent(campaignContentResponse.data);
        }
    };

    return (
        <>
            <Helmet>
                <title>{metadata?.title}</title>
                <meta name="description" content={`${metadata?.description}`} />
                <meta property="og:title" content={`${metadata?.title}`} />
                <meta property="og:description" content={`${metadata?.description}`} />
                <meta property="og:image" content={`${metadata?.openGraphImage}`} />
                <meta property="og:url" content={`${content?.campaignDomain}`} />

                <link
                    rel="icon"
                    href={
                        metadata?.favicon ||
                        'https://upload.wikimedia.org/wikipedia/commons/4/48/BLANK_ICON.png'
                    }
                />
            </Helmet>
            <div className={`site-wrapper`}>
                <div className={`loading-wrapper ${!configLoading && !loading && 'done'}`}>
                    <div className="loading-spinner" />
                </div>
                {!configLoading && (
                    <Routes>
                        {MyRoutes.map(r => {
                            const Element =
                                isMobile || r.availableOnDesktop ? r.component : MobileOnly;
                            return <Route key={r.name} path={r.path} element={<Element />} />;
                        })}

                        <Route key={'Unknown'} path={'*'} element={<NotFoundPage />} />
                    </Routes>
                )}
            </div>
        </>
    );
}

export default App;
